import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";
import { Shield, Loader2, AlertCircle } from "lucide-react";

export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        applyAuth(data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail) || "Autenticazione Google fallita");
      }
    })();
  }, [applyAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background pgp-grid-bg">
      <div className="flex flex-col items-center gap-4 text-center px-6" data-testid="auth-callback">
        <div className="h-11 w-11 rounded-xl bg-amber-500 flex items-center justify-center pgp-glow">
          <Shield className="h-6 w-6 text-[#0a0d14]" strokeWidth={2.4} />
        </div>
        {error ? (
          <>
            <AlertCircle className="h-6 w-6 text-red-400" />
            <p className="text-sm text-red-400 max-w-sm">{error}</p>
            <button onClick={() => navigate("/login", { replace: true })}
              className="text-sm text-amber-400 hover:underline" data-testid="back-to-login">
              Torna al login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="h-6 w-6 animate-spin text-amber-500" />
            <p className="text-sm text-slate-400 font-mono">Accesso con Google in corso…</p>
          </>
        )}
      </div>
    </div>
  );
}
